/* ========================================================================
   PLP カード variant 同期
   swatch 切替時のカード画像、URL、価格、quick add、wishlist 状態を同期する。
   ======================================================================== */
(() => {
  const wishlistButtonData = window.AuremePlpWishlistButtonData;
  const syncCardButtonsFromVariant = wishlistButtonData?.syncCardButtonsFromVariant;
  if (typeof syncCardButtonsFromVariant !== 'function') {
    /* wishlist button data 更新と再同期通知だけをスキップし、画像、URL、価格、quick add の同期は継続する */
    console.error('[aureme-plp-card-variant-sync] wishlist button data helper is not loaded.');
  }

  const plpPriceNumberFormat = new Intl.NumberFormat('ja-JP');

  /* img 要素の src / srcset / alt をまとめて差し替えるヘルパー */
  function updateImageAttrs(image, src, srcset, alt) {
    if (!image) return;
    if (src) image.setAttribute('src', src);
    if (srcset) image.setAttribute('srcset', srcset);
    if (alt) image.setAttribute('alt', alt);
  }

  /* scope 内のリンク / URL 属性を nextUrl へ同期するヘルパー */
  function syncUrlAttrs(scope, nextUrl) {
    for (const link of scope.querySelectorAll('[data-aureme-plp-card-link]')) {
      link.setAttribute('href', nextUrl);
    }
    /* swatch 自体の遷移先は色ごとの固定値なので、選択中 URL で上書きしない */
    for (const trigger of scope.querySelectorAll(
      '[data-product-url]:not([data-aureme-plp-card-swatch])',
    )) {
      trigger.setAttribute('data-product-url', nextUrl);
    }
    for (const bulkModal of scope.querySelectorAll('bulk-modal[data-url]')) {
      bulkModal.setAttribute('data-url', nextUrl);
    }
  }

  function syncBulkModalImages(bulkModalDialog, nextSrc, nextSrcset, nextAlt) {
    if (!bulkModalDialog) return;

    for (const image of bulkModalDialog.querySelectorAll('[data-aureme-plp-bulk-modal-image]')) {
      updateImageAttrs(image, nextSrc, nextSrcset, nextAlt);
    }
  }

  function syncVariantIdInputs(card, nextVariantId) {
    if (!nextVariantId) return;

    for (const input of card.querySelectorAll('[data-aureme-plp-card-variant-id]')) {
      input.value = nextVariantId;
    }
  }

  function syncWishlistVariantData(card, nextVariantData) {
    if (typeof syncCardButtonsFromVariant !== 'function') return;

    syncCardButtonsFromVariant(card, nextVariantData);
  }

  function normalizePlpPrice(value) {
    return Math.max(0, parseInt(value || 0, 10) || 0);
  }

  /* Shopify の価格 data 属性は最小通貨単位なので、PLP 表示用に円表記へ戻す */
  function formatPlpPrice(value) {
    return `￥${plpPriceNumberFormat.format(Math.round(normalizePlpPrice(value) / 100))}`;
  }

  function syncCardPrice(card, nextPrice, nextCompareAtPrice, nextIsAvailable) {
    if (nextPrice == null || nextPrice === '') return;

    const price = normalizePlpPrice(nextPrice);
    const compareAtPrice = normalizePlpPrice(nextCompareAtPrice);
    const isAvailable = nextIsAvailable !== 'false';
    const priceElement = card.querySelector('[data-aureme-plp-card-price]');
    const saleBadge = card.querySelector('[data-aureme-plp-card-sale-badge]');

    if (priceElement) {
      priceElement.textContent = formatPlpPrice(price);
    }

    if (saleBadge) {
      saleBadge.hidden = !(isAvailable && compareAtPrice > price);
    }
  }

  function syncPlpCardVariantState(card, dataset) {
    const bulkModalId = card.dataset.auremeBulkModalId;
    const bulkModalDialog = bulkModalId ? document.getElementById(bulkModalId) : null;
    const {
      mediaSrc: nextSrc,
      mediaSrcset: nextSrcset,
      mediaAlt: nextAlt,
      productUrl: nextUrl,
      variantId: nextVariantId,
      price: nextPrice,
      compareAtPrice: nextCompareAtPrice,
      isAvailable: nextIsAvailable,
    } = dataset;

    updateImageAttrs(
      card.querySelector('[data-aureme-plp-card-primary]'),
      nextSrc,
      nextSrcset,
      nextAlt,
    );
    if (nextUrl) {
      syncUrlAttrs(card, nextUrl);

      /* bulk quick add の modal-dialog は body 直下へ移るため、カード外へ退避した modal も同時に同期する */
      if (bulkModalDialog) {
        syncUrlAttrs(bulkModalDialog, nextUrl);
      }
    }

    syncBulkModalImages(bulkModalDialog, nextSrc, nextSrcset, nextAlt);
    syncVariantIdInputs(card, nextVariantId);
    syncWishlistVariantData(card, dataset);
    syncCardPrice(card, nextPrice, nextCompareAtPrice, nextIsAvailable);
  }

  function applySwatchSelectedState(swatchButton, isSelected) {
    swatchButton.classList.toggle('is-selected', isSelected);
    swatchButton.setAttribute('aria-pressed', String(isSelected));
  }

  function syncPlpCardSwatchSelection(card, selectedButton) {
    for (const swatchButton of card.querySelectorAll('[data-aureme-plp-card-swatch]')) {
      applySwatchSelectedState(swatchButton, swatchButton === selectedButton);
    }
  }

  function handleSwatchSelection(button) {
    const card = button.closest('[data-aureme-plp-card]');
    if (!card) return;

    syncPlpCardVariantState(card, button.dataset);
    syncPlpCardSwatchSelection(card, button);
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const swatchButton = target.closest('[data-aureme-plp-card-swatch]');
    if (!swatchButton) return;

    event.preventDefault();
    handleSwatchSelection(swatchButton);
  });
})();
